/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_CostInputs */

const en_mk_sol_startup_cost = /** @type {(inputs: Mk_Sol_Startup_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seven seats on the Team plan: Rp 693,000 a month. Plenty of teams this size start on the Free plan first, just to prove the way of working.`)
};

const id_mk_sol_startup_cost = /** @type {(inputs: Mk_Sol_Startup_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tujuh kursi paket Tim: Rp 693.000 per bulan. Banyak tim seukuran ini memulai dari paket Gratis dulu untuk membuktikan cara kerjanya.`)
};

/**
* | output |
* | --- |
* | "Seven seats on the Team plan: Rp 693,000 a month. Plenty of teams this size start on the Free plan first, just to prove the way of working." |
*
* @param {Mk_Sol_Startup_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_cost = /** @type {((inputs?: Mk_Sol_Startup_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_cost(inputs)
	return en_mk_sol_startup_cost(inputs)
});